//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  PinterestGatewayUser,
  GetPinterestUserResponse,
  GetPinterestUserBoardsResponseV2,
  GetPinterestUserBoardsResultV2,
} from '@bvengineering/pinterest-gateway-service-types';

import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const PINTEREST_DEFAULT_ENDPOINT = '/api/v1/user';
const PINTEREST_V2_ENDPOINT = '/api/v2/user';

const pinterestGatewayUserFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'pinterest_dashboard_gateway',
    `${PINTEREST_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

const pinterestGatewayUserV2Fetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'pinterest_dashboard_gateway',
    `${PINTEREST_V2_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Gets the clients pinterest boards
 *
 * GET /api/v2/user/boards
 */
export const getBoardsPaged = async (
  bookmark?: string,
): Promise<GetPinterestUserBoardsResultV2> => {
  const params = makeParams({ bookmark });
  const res = await pinterestGatewayUserV2Fetch(`/boards?${params}`);

  return (await res.json<GetPinterestUserBoardsResponseV2>()).data;
};

/**
 * Gets the clients pinterest user
 *
 * GET /api/v1/user
 */
export const getUser = async (
  init?: RequestInit,
): Promise<PinterestGatewayUser | undefined> => {
  const res = await pinterestGatewayUserFetch(``, init);

  return (await res.json<GetPinterestUserResponse>()).data;
};
